"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require('classnames');
var VideoEmbed = /** @class */ (function (_super) {
    tslib_1.__extends(VideoEmbed, _super);
    function VideoEmbed() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoEmbed.prototype.slug = function () {
        return "https://www.youtube.com/embed/" + this.props.slug;
    };
    VideoEmbed.prototype.render = function () {
        if (!this.props.slug)
            return null;
        var classes = classNames('video-embed', { 'video-embed--narrow': this.props.narrow });
        return (React.createElement("div", { className: classes, id: this.props.jumplinkSlug || null },
            React.createElement("div", { className: "video-embed__inner" },
                React.createElement("iframe", { src: this.slug(), title: this.props.caption, frameBorder: "0", allowFullScreen: true })),
            this.props.caption &&
                React.createElement("div", { className: "video-embed__caption" }, this.props.caption)));
    };
    return VideoEmbed;
}(React.Component));
exports.default = VideoEmbed;
//# sourceMappingURL=video_embed.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/video_embed.js
// module id = PmtR
// module chunks = 20 21